// Orbe geolocation popup trigger bound to header localization button
// Requires: Orbe Geolocation Button block added (e.g. to cart drawer) + Geolocation Popup embed enabled
document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('[data-header-localization-trigger]');
  if (!triggers.length) return;

  const openViaOrbito = () => {
    if (window.orbito && typeof window.orbito.openModalWithoutRefresh === 'function') {
      try {
        window.orbito.openModalWithoutRefresh();
        return true;
      } catch (error) {
        console.error('[Orbe] openModalWithoutRefresh failed:', error);
      }
    }
    return false;
  };

  const openViaButtonClick = () => {
    const orbeButton = document.querySelector('.md-orbe-country-selector, [class*="orbe"][class*="country-selector"]');
    if (orbeButton) {
      orbeButton.click();
      return true;
    }
    return false;
  };

  const openOrbePopup = () => {
    if (openViaOrbito()) return;
    if (openViaButtonClick()) return;
    // orbito not ready: poll briefly then try button click
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (openViaOrbito() || openViaButtonClick()) {
        clearInterval(timer);
      } else if (attempts >= 50) {
        clearInterval(timer);
      }
    }, 100);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openOrbePopup();
    });
  });
});

